import { SpanTracker } from "./util.js";
export class BrowserConsoleSubscriber {
    options;
    tracker = new SpanTracker();
    constructor(options) {
        this.options = options;
    }
    onEvent = (event) => {
        const source = this.getSource(event.fields);
        const group = this.getGroup(event.fields);
        console[event.level](`[${event.level}] [${group}] ${event.message}${source ? ` ${source}` : ""}`, ...(event.error ? [event.error] : []), event.fields);
    };
    onEnter = (span) => {
        this.tracker.enter(span, {
            mark: this.options?.performance ? performance.mark(span.name) : undefined,
            start: performance.now(),
        });
        const source = this.getSource(span.fields);
        const group = this.getGroup(span.fields);
        console[span.level](`[${span.level}] [${group}] ▶️ ${span.name}${source ? ` ${source}` : ""}`, span.fields);
        return span;
    };
    onExit = (span) => {
        const entry = this.tracker.exit(span);
        if (!entry)
            return;
        const duration = performance.now() - entry.start;
        const source = this.getSource(span.fields);
        const group = this.getGroup(span.fields);
        console[span.level](`[${span.level}] [${group}] ✅ ${span.name} (${duration.toFixed(1)}ms)${source ? ` ${source}` : ""}`, span.fields);
    };
    getGroup(fields) {
        if (!Array.isArray(fields.tags))
            return "";
        return fields.tags?.join(":") ?? "";
    }
    getSource(fields) {
        if (typeof fields.source !== "string")
            return undefined;
        return fields.source.includes("localhost") || fields.source.includes(".rs") ? fields.source : undefined;
    }
}
//# sourceMappingURL=browser.js.map